import React, { Component } from 'react';
import Search from '../Home/Search';
import { Link } from 'react-router-dom';

export class AboutSubscription extends Component {
    displayName = AboutSubscription.name

    render() {
        return (
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-9">
                            <p className="TitlePadding Title">About subscriptions</p>
                            <p className="TitlePadding BookBody">On Kluwer Law Online, we offer:</p>

                            <p className="paddingL">  <ul className="ManualUl">
                                <li>Our full collection of journals, including full archives; </li>
                                <li>An increasing selection of manual publication;</li>
                                <li>The complete 25 International Encyclopaedias of Laws.</li>
                                <li>Browsable tables of contents;</li>
                                <li>Bibliographical information in HTML format;</li>
                                <li>Full-text documents in PDF format (to view and print PDF files, please install the free Adobe Reader);</li>
                                <li>Advanced navigation and search functionality within and across titles;</li>
                                <li>Online availability 3 to 4 weeks prior to print publication</li>

                            </ul>
                            </p>
                            <p className="TitlePadding BookBody">
                                Searching, browsing and bibliographical information are provided free of charge - no subscription needed. Full text documents are available for subscribers only. Access control can be provided based on IP address, referring URL and/or user ID and password and for single or multiple concurrent users. Subscriptions can extend to all current and future titles, or can be limited to a specified subset of titles. Please
                                <Link to="/ContactSales" classname="LinkClass"> contact our sales department</Link> if
you would like more information, or a subscription.
                                <br></br>
                                <br></br>
                                The PDF version of all journal articles and chapters can also be purchased individually.
                            </p>

                            <p className="TitlePadding BookBody">
                                It is now also possible to purchase a 12-month print subscriptions via Kluwer Law Online. Please note that these print subscriptions are calendar subscriptions which will be active from 1 January to 31 December of the year in which they are purchased. This means that if a subscription is ordered in the middle of the year, the issues already published will be back-filled and the subscription will end at the end of the calendar year.

                                </p>
                        </div>
                    </div>

                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer Section/AboutSubscription.jsx